import { seo } from "app/utils";

const useOrganizationTitle = () => {
  const capitalizeFirstLetters = (str: string) => {
    const words = str.split(" ");
    const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
    return capitalizedWords.join(" ");
  };

  const getOrgName = (organizationName: string) => {
    if (organizationName === "activisionblizzard") {
      return "Activision Blizzard";
    }
    if (organizationName === "talentacquisitionweek") {
      return "Talent Acquisition Week";
    }
    if (organizationName === "westmonroe") {
      return "West Monroe";
    }
    return capitalizeFirstLetters(organizationName);
  };

  const updateSeoTitle = (organizationName: string, text?: string) => {
    const orgName = getOrgName(organizationName);
    seo({
      title: `${orgName} - ${text || "Culture Page"}`
    });
  };

  return { updateSeoTitle };
};

export default useOrganizationTitle;
